<template>
  <div class="mt-2 mb-2">
    <div class="label mt-4 mb-1">Assigned To</div>
    <div class="d-flex align-items-center" :class="{ 'cursor-pointer': !disabled }" v-if="user" id="assignUser">
      <div class="avatar text-uppercase">
        {{ user.shortName.substr(0, 3) }}
      </div>
      <div class="ml-2">{{ user.firstName }}</div>
    </div>

    <div class="d-flex align-items-center" :class="{ 'cursor-pointer': !disabled }" v-else id="assignUser">
      <div class="avatar text-uppercase">N/A</div>
      <div class="ml-2">unassigned</div>
    </div>

    <b-popover target="assignUser" ref="assignUser" :disabled="disabled" triggers="click blur">
      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Assign User</div>
      <hr class="mt-2 mb-2" />
      <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

      <div class="bi-label-container">
        <div class="user-entry remove mb-2" @click="assignUser(null)" v-if="user">
          <div class="avatar text-uppercase">N/A</div>
          <div class="ml-2">Remove assignment</div>
        </div>

        <div v-for="user in filteredUsers" :key="user.id" class="mb-2">
          <div class="user-entry" @click="assignUser(user)">
            <div class="avatar text-uppercase">
              {{ user.shortName.substring(0, 3) }}
            </div>
            <div class="ml-2">{{ user.firstName + ' ' + user.lastName }}</div>
          </div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { AvailabilityEntityType, UserDto } from '@/apiclient/apiclient_generated';
  import { UserModule, UserStore } from '@/store/user';
  import { BoardModule, BoardStore } from '@/store/board';
  import { orderBy } from 'lodash';

  @Component
  export default class BoardItemAssignedUser extends Vue {
    private userStore: UserModule = UserStore;
    private boardStore: BoardModule = BoardStore;
    @Prop() value: UserDto;
    @Prop() disabled;

    private filter = '';

    get filteredUsers() {
      let users = this.userStore.availableUsers;

      if (this.value) {
        users = users.filter((_) => _.id != this.value.id);
      }

      return orderBy(
        users.filter((item) => item.displayName.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0),
        ['firstName', 'lastName']
      );
    }

    mounted() {
      const userParams = {
        entityType: AvailabilityEntityType.Board,
        entityId: this.boardStore.board.id,
      };

      this.userStore.getAvailableUsers(userParams);
    }

    get user(): UserDto {
      return this.value;
    }

    async assignUser(user: UserDto) {
      const popover: any = this.$refs.assignUser;
      if (popover) {
        this.filter = '';
        popover.doClose();
      }

      this.$emit('boardItemAssignedUserUpdated', user);
    }
  }
</script>

<style scoped lang="scss">
  .label {
    font-weight: bold;
    font-size: 1rem;
  }

  .bi-label-container {
    max-height: 300px;
    height: 300px;
    min-width: 240px;
    overflow-y: auto;
  }

  .bi-label-container::-webkit-scrollbar {
    width: 8px;
  }

  .bi-label-container::-webkit-scrollbar-track {
    background: #ddd;
    border-radius: 5px;
  }

  .bi-label-container::-webkit-scrollbar-thumb {
    background: #999;
    border: 2px solid #ddd;
    border-radius: 5px;
  }

  .user-entry {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0.25rem;
    border-radius: 4px;
    transition: all 0.1s ease-in-out;

    &.remove:hover {
      background: #e74c3c !important;
    }

    &:hover {
      background: #eaeaea;
      .avatar {
        background: darken(#eaeaea, 10%);
      }
    }
  }

  .bi-label,
  no-available-labels {
    background-color: #4e667d;
  }
</style>
